import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Keyboard and screen-reader pieces shared by the five course table-of-contents
// pages. Each page keeps its own data, gating and markup. The styles live in
// pages/examples/TableOfContent.css, which every table imports.

// An open lesson is a real link. A locked one is a button that stays focusable
// (aria-disabled, not disabled), so a screen reader can reach it and hear why.
// A lesson with no page yet (some JavaScript ones) is plain text, as before.
export const TocLesson = ({ to, locked, onLocked, className, style, children }) =>
  !locked && !to ? (
    <div className={className} style={{ ...style, cursor: "default" }}>
      {children}
    </div>
  ) : locked ? (
    <button
      type="button"
      aria-disabled="true"
      className={`toc-lesson-btn ${className}`}
      style={style}
      onClick={onLocked}
    >
      {children}
    </button>
  ) : (
    <Link to={to} className={`toc-lesson-link ${className}`} style={style}>
      {children}
    </Link>
  );

// The status the lesson icons show, as text.
export const LessonStatus = ({ completed, locked }) => {
  const { t } = useTranslation();
  const parts = [];
  if (completed) parts.push(t("table.statusCompleted"));
  if (locked) parts.push(t("table.statusLocked"));
  else if (!completed) parts.push(t("table.statusAvailable"));
  return <span className="sr-only">{parts.join(", ")}</span>;
};

// How many times a locked lesson was pressed in this module.
export const useLockedNote = () => {
  const [count, setCount] = useState(0);
  return [count, () => setCount((n) => n + 1)];
};

// Replaces the old window.alert. The region is always in the page so screen
// readers announce it; a new key per press makes a repeat announce again.
export const LockedNote = ({ count }) => {
  const { t } = useTranslation();
  return (
    <p role="status" className="toc-locked-note">
      {count > 0 && <span key={count}>{t("table.lockedLessonAlert")}</span>}
    </p>
  );
};
